export const GALLERY_FALLBACK = [
    {
        item_id: "b1",
        title: "Terrasse — ragréage béton puis carrelage",
        category: "carrelage",
        location: "Vexin français",
        before: "/chantiers/terrasse-avant.jpg",
        after: "/chantiers/terrasse-apres.jpg",
    },
    {
        item_id: "b2",
        title: "Ragréage du support béton",
        category: "sols",
        location: "Vexin français",
        before: null,
        after: "/chantiers/ragreage-beton.jpg",
    },
    {
        item_id: "b3",
        title: "Pose de parquet / vinyle intérieur",
        category: "parquet",
        location: "Vexin français",
        before: null,
        after: "/chantiers/pose-parquet-vinyle.jpg",
    },
];

export const CATEGORIES = [
    { key: "tout", label: "Tout voir" },
    { key: "peinture", label: "Peinture" },
    { key: "parquet", label: "Parquet" },
    { key: "carrelage", label: "Carrelage" },
    { key: "sols", label: "Sols souples" },
    { key: "facade", label: "Façades" },
];

export const REVIEWS = [
    {
        avis_id: "a1",
        author: "Martine D.",
        city: "Chaumont-en-Vexin",
        rating: 5,
        date: "2026",
        text:
            "Travail soigné du début à la fin. M. Solino a repris toute la peinture du rez-de-chaussée : préparation sérieuse, zéro poussière en fin de journée, et un rendu vraiment net.",
    },
    {
        avis_id: "a2",
        author: "Julien M.",
        city: "Gisors",
        rating: 5,
        date: "2026",
        text:
            "Pose de parquet dans deux chambres et le couloir. Conseils clairvoyants sur le choix du stratifié, chantier livré dans les délais annoncés.",
    },
    {
        avis_id: "a3",
        author: "Sophie L.",
        city: "Méru",
        rating: 5,
        date: "2026",
        text:
            "Devis rapide, tarif respecté. La salle de bain carrelée grand format est magnifique. Je recommande sans hésiter.",
    },
];

export const POSTS = [
    {
        slug: "choisir-carrelage-gisors",
        title: "Comment choisir son carrelage à Gisors — conseils d'un artisan local",
        excerpt:
            "Format, adhérence, pièces d'eau, budget : le guide du carrelage pour les maisons de Gisors, écrit par un artisan qui y pose chaque mois.",
        cover: "https://images.pexels.com/photos/7546317/pexels-photo-7546317.jpeg?auto=compress&cs=tinysrgb&w=1600",
        date: "2026-03-05",
        minRead: 5,
        sections: [
            {
                h: "Le parc immobilier de Gisors demande des choix adaptés",
                b: [
                    "Gisors mêle maisons anciennes du centre historique et pavillons plus récents — et ces deux mondes n'ont pas les mêmes exigences en matière de carrelage. Sur une maison ancienne, les supports bougent : mieux vaut un format moyen et des joints plus larges qu'un grand format rigide qui fissurera.",
                    "Dans un pavillon des années 70-90, le sol d'origine est souvent du grès vieillissant : le remplacement par un carrelage moderne est l'un des travaux de rénovation intérieure les plus rentables du secteur.",
                ],
            },
            {
                h: "Les critères techniques qui comptent vraiment",
                b: [
                    "Trois chiffres à regarder avant l'esthétique : la résistance à l'usure (classe PEI I à V pour un sol), l'adhérence (norme R9 à R11 pour une entrée ou une pièce d'eau) et la résistance au gel pour toute pose extérieure — terrasse, dalle plombante sur plots.",
                    "Le grand format fait peu de joints et agrandit une pièce, mais il exige un support parfaitement plan : le ragréage est alors incontournable. Un bon artisan vous le dira avant de vous vendre des dalles de 120 cm.",
                ],
            },
            {
                h: "Quelle pièce, quel carrelage ?",
                b: [
                    "Cuisine : grès cérame grand trafic, finition mate pour masquer l'entretien quotidien. Salle de bain : carrelage mural avec étanchéité soignée (SEL) et sol antidérapant R10 minimum. Entrée : grand trafic ou dalles podotactiles si vous recevez du public. Chambres : le carrelage fonctionne, mais beaucoup préfèrent la chaleur d'un parquet stratifié.",
                    "Pour les escaliers, les marches carrelées (70 à 150 € la marche) ou les marches intégrales transforment un escalier fatigué en élément central de l'entrée.",
                ],
            },
            {
                h: "Quel budget pour du carrelage à Gisors ?",
                b: [
                    "En pose seule, comptez entre 25 et 60 €/m² selon le format et la complexité, le carrelage venant s'ajouter selon la gamme. La faïence murale démarre autour de 45 €/m². Prévoyez le ragréage (à partir de 17 €/m²) si le support est irrégulier.",
                    "Méfiez-vous des tarifs trop bas promis au mètre carré sans préparation : c'est la préparation qui garantit un carrelage qui ne sonne pas creux dans deux ans.",
                    "Où acheter votre carrelage près de Gisors ? Les grandes enseignes de l'Oise et de l'Eure conviennent pour les gammes courantes ; pour un grès cérame grand format ou un imitation bois de qualité, passez par un distributeur de carrelage professionnel — nous vous orientons vers les bons partenaires selon votre budget. Vous pouvez aussi fournir vous-même le carrelage : nous posons ce que vous avez choisi, après avoir vérifié qu'il convient au support.",
                ],
            },
            {
                h: "Un artisan local, à 15 minutes de Gisors",
                b: [
                    "Solino Pro est basé à Chaumont-en-Vexin, à un quart d'heure de Gisors : visite rapide, devis détaillé sous 48 h, suivi de chantier quotidien et interlocuteur unique de la première question à la dernière plinthe.",
                    "Vous préparez une rénovation intérieure à Gisors ou dans les communes voisines ? Décrivez votre projet en 2 minutes sur notre formulaire de devis — gratuit, sans engagement, chiffré sous 48 h.",
                ],
            },
        ],
    },
    {
        slug: "renovation-interieure-vexin-par-ou-commencer",
        title: "Rénovation intérieure dans le Vexin : par où commencer ?",
        excerpt:
            "Une pièce ou toute la maison, sols ou murs, quel budget dans quel ordre : la méthode d'un artisan du Vexin pour démarrer sa rénovation sans stress.",
        cover: "https://images.unsplash.com/photo-1597665863042-47e00964d899?q=80&w=1600&auto=format&fit=crop",
        date: "2026-03-18",
        minRead: 5,
        sections: [
            {
                h: "Étape 1 : définir le périmètre réel",
                b: [
                    "Première erreur courante : vouloir tout faire en même temps. Prenez dix minutes et listez, pièce par pièce, ce qui vous agace vraiment — un sol fatigué, des murs à repeindre, une cuisine à rafraîchir. Classez en trois colonnes : urgent, utile, plus tard.",
                    "Dans le Vexin, beaucoup de maisons n'ont été ni repeintes ni re-solées depuis vingt ans : inutile de tout enchaîner en trois semaines. Une rénovation intérieure bien phasée se vit mieux et se finance mieux.",
                ],
            },
            {
                h: "Étape 2 : les sols et les murs dans le bon ordre",
                b: [
                    "L'ordre professionnel est simple : dépose de l'ancien, préparation des supports (rebouchage, ragréage du sol si besoin), puis peinture des murs et plafonds, et enfin pose des revêtements de sol en flottant — stratifié ou vinyle — suivie des plinthes et finitions.",
                    "Pourquoi ce sens ? La préparation des murs fait tomber de la poussière, et un sol neuf n'a pas à subir le chantier. Un artisan qui fait les deux corps d'état (comme Solino Pro : peinture et sols) coordonne tout lui-même, sans attente entre deux entreprises.",
                ],
            },
            {
                h: "Étape 3 : chiffrer sans se tromper",
                b: [
                    "Un devis sérieux détaille poste par poste : préparation, fournitures, pose, finitions. Côté ordres de grandeur dans notre secteur : peinture à partir de 18 €/m², parquet stratifié pose seule entre 25 et 40 €/m², carrelage standard entre 25 et 60 €/m², ragréage à partir de 17 €/m².",
                    "Exigez que la préparation soit écrite noir sur blanc : c'est elle qui sépare une rénovation qui dure d'un chantier à refaire.",
                    "Anticipez enfin les imprévus : dans les maisons anciennes du Vexin, on découvre parfois une humidité sous un ancien revêtement ou un enduit à reprendre. Prévoyez une marge de 10 à 15 % sur votre budget et un ordre de priorité entre les pièces : c'est ce que nous faisons sur chaque devis Solino Pro, pour que les surprises ne coûtent jamais une abandon de chantier.",
                ],
            },
            {
                h: "Étape 4 : choisir un artisan du coin",
                b: [
                    "Chaumont-en-Vexin, Gisors, Méru, Marines, Magny-en-Vexin, Chars, Beauvais, Pontoise : dans un rayon de 40 km, un artisan local passe voir votre chantier vite, chiffre vite, et reste joignable après. La proximité n'est pas un détail — c'est votre assurance suivi.",
                    "Vérifiez aussi les bases : SIRET, assurance décennale, devis détaillé gratuit. Trois lignes qui doivent figurer sur chaque devis, comme les nôtres.",
                ],
            },
            {
                h: "Par où commencer concrètement ?",
                b: [
                    "Par la pièce où vous vivez le plus, par le sol qui vous agace le plus, ou par un simple appel. Décrivez votre projet sur notre formulaire de devis gratuit (2 minutes, photos bienvenues) : vous recevez un chiffrage clair sous 48 h ouvrées, ajusté à votre maison dans le Vexin.",
                ],
            },
        ],
    },
    {
        slug: "parquet-stratifie-ou-carrelage",
        title: "Parquet stratifié ou carrelage : lequel choisir pour votre maison ?",
        excerpt:
            "Chaleur du stratifié ou solidité du carrelage : les vrais critères de choix pièce par pièce, avec les budgets de pose dans l'Oise et le Val-d'Oise.",
        cover: "https://images.unsplash.com/photo-1684793219162-8b2e705f0859?q=80&w=1600&auto=format&fit=crop",
        date: "2026-03-25",
        minRead: 5,
        sections: [
            {
                h: "Deux sols, deux façons de vivre",
                b: [
                    "Le parquet stratifié et le carrelage sont les deux grands gagnants de la rénovation intérieure dans le Vexin — et le bon choix dépend surtout de la pièce et de votre quotidien, pas de la mode.",
                    "Le stratifié apporte chaleur visuelle, douceur au pied et un budget maîtrisé. Le carrelage apporte une durée de vie de vingt ans et plus, une résistance totale à l'eau et un entretien sans état d'âme.",
                ],
            },
            {
                h: "Le parquet stratifié : le confort à petit budget",
                b: [
                    "Posé en flottant sur une sous-couche acoustique, le stratifié se pose en une journée, sans colle ni poussière. Les décors actuels imitent le chêne avec un réalisme bluffant. En pose seule, comptez entre 25 et 40 €/m², ragréage en plus si le support est irrégulier (à partir de 17 €/m²).",
                    "Sa limite : l'eau. Réservez-le aux pièces sèches — chambres, séjour, couloirs — et choisissez une classe d'usage adaptée (AC4 en pièces de vie).",
                ],
            },
            {
                h: "Le carrelage : l'investissement longue durée",
                b: [
                    "Grès cérame au sol, grand format ou imitation bois, le carrelage encaisse tout : passage, eau, chaises roulantes de la cuisine. En pose seule, comptez entre 25 et 60 €/m² selon le format, marches d'escalier carrelées à part (70 à 150 €/marche).",
                    "Sa contrepartie : un support parfaitement plan (ragréage souvent nécessaire) et une sensation plus froide — compensée par un chauffage au sol ou quelques tapis bien choisis.",
                    "Bon à savoir si votre maison du Vexin est équipée d'un chauffage au sol basse température : les deux sols sont compatibles, à condition de choisir les bonnes épaisseurs et résistances. C'est un point que nous vérifions systématiquement avant de vous recommander l'un ou l'autre.",
                ],
            },
            {
                h: "Notre répartition gagnante, pièce par pièce",
                b: [
                    "Entrée et cuisine : carrelage ou vinyle en lames pour l'eau et le trafic. Séjour : les deux fonctionnent — stratifié si vous voulez la chaleur, carrelage si la maison accueille beaucoup. Chambres : stratifié, sans hésiter. Salle de bain : carrelage, sans discussion. Escalier : habillage bois ou marches carrelées selon le style.",
                    "Cette répartition mixte est la plus demandée chez nos clients du Vexin : elle met chaque sol là où il est le meilleur.",
                ],
            },
            {
                h: "Alors, stratifié ou carrelage ?",
                b: [
                    "La vraie question : combien d'années voulez-vous garder ce sol, et qui marche dessus ? Petits pieds ou pattes, cuisine très vivante, chauffage au sol — trois paramètres qui changent la réponse.",
                    "Décrivez-nous votre maison depuis notre formulaire de devis gratuit : Solino Pro, artisan à Chaumont-en-Vexin, intervient dans un rayon de 40 km et vous chiffre chaque option sous 48 h, poste par poste.",
                ],
            },
        ],
    },
    {
        slug: "quel-sol-choisir-cuisine",
        title: "Quel sol choisir pour une cuisine ? Le guide sans langue de bois",
        excerpt:
            "Carrelage, vinyle, parquet : chaque sol a ses arguments. Voici comment trancher selon votre usage, votre budget et votre style.",
        cover: "https://images.unsplash.com/photo-1684793219162-8b2e705f0859?q=80&w=1600&auto=format&fit=crop",
        date: "2026-01-12",
        minRead: 4,
        sections: [
            {
                h: "La cuisine : la pièce la plus exigeante de la maison",
                b: [
                    "Chutes d'ustensiles, projections d'eau, chaises qu'on traîne, pas de talons ou les roulettes du tabouret : peu de pièces sollicitent un sol comme la cuisine. Le bon critère de choix n'est donc pas le style d'abord, mais la résistance à l'eau et à l'usure.",
                    "Deuxième critère : la facilité d'entretien. Un sol de cuisine se lave plusieurs fois par semaine, souvent vite. Mieux vaut une surface lisse ou peu texturée, qui ne retient ni graisse ni miettes.",
                ],
            },
            {
                h: "Le vinyle en lames : le choix pragmatique",
                b: [
                    "Le vinyle en lames (type SPC) est aujourd'hui le meilleur compromis pour une cuisine : totalement imperméable, résistant aux chocs, silencieux, et les imitations bois actuelles sont bluffantes. Il se pose en une journée et supporte les roulettes de chaises.",
                    "Comptez une pose à partir de 25 €/m², préparation du support incluse si celui-ci est sain.",
                ],
            },
            {
                h: "Le carrelage : le choix de la durée",
                b: [
                    "Le carrelage reste l'option la plus durable : vingt, trente ans sans broncher. Grès cérame imitation bois ou grands formats mats, il tolère tout — sauf la fatigue des jambes et la casse de la vaisselle.",
                    "Côté budget, la pose seule démarre autour de 25 €/m² pour un carrelage standard et monte jusqu'à 60 €/m² selon le format choisi, le carrelage lui-même venant s'ajouter selon la gamme.",
                ],
            },
            {
                h: "Le parquet : possible, à une condition",
                b: [
                    "On peut tout à fait mettre du parquet dans une cuisine, à condition de choisir un parquet vernis ou huilé en usine (résistance renforcée) et d'être vigilant sur les zones humides : une natte sous l'évier et un joint silicone soigné en périphérie.",
                    "L'argument du parquet : la chaleur qu'il apporte, irrépliable dans une cuisine ouverte sur le séjour.",
                ],
            },
            {
                h: "En résumé",
                b: [
                    "Cuisine très vivante, enfants, chiens : vinyle en lames. Maison long terme, budget confortable : carrelage grand format. Cuisine ouverte où l'esthétique prime : parquet stratifié bien posé. Et pour trancher avec vos vraies contraintes, demandez-nous : le devis est gratuit, et le conseil aussi.",
                ],
            },
        ],
    },
    {
        slug: "prix-peinture-m2-oise",
        title: "Prix de la peinture au m² dans l'Oise : ce que vous paierez vraiment",
        excerpt:
            "18 €/m², 35 €/m², 60 €/m² ? On décortique ce qui fait varier le prix d'un chantier de peinture, préparation comprise.",
        cover: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?q=80&w=1600&auto=format&fit=crop",
        date: "2026-02-03",
        minRead: 5,
        sections: [
            {
                h: "Les fourchettes honnêtes du marché",
                b: [
                    "Dans l'Oise et le Val-d'Oise, un peintre facture généralement entre 18 et 35 €/m² pour des murs, et jusqu'à 45 €/m² quand plafonds et boiseries entrent dans le chantier. En dessous de 15 €/m², la préparation est presque toujours rognée — c'est là que se cachent les mauvaises surprises.",
                    "À Solino Pro, nos tarifs indicatifs démarrent à 18 €/m² pour un mur préparé et 24 €/m² pour une pièce complète murs + plafond, fourniture de peinture professionnelle incluse.",
                ],
            },
            {
                h: "Ce qui fait grimper (ou baisser) le devis",
                b: [
                    "L'état du support est le facteur n°1 : un mur à reboucher et à poncer peut représenter autant de temps que la peinture elle-même. Viennent ensuite la hauteur sous plafond (échafaudage pour les plafonds), le nombre de couleurs (les changements de teinte multiplient les masquages) et la finition choisie.",
                    "À l'inverse, un logement vide, déjà préparé, en une seule teinte, c'est le scénario où notre tarif plancher s'applique.",
                ],
            },
            {
                h: "Prestation ou fourniture : ce que le m² doit inclure",
                b: [
                    "Un devis sérieux au m² mentionne trois choses : la préparation (rebouchage, ponçage, sous-couche), le nombre de couches, et la peinture elle-même avec sa marque et sa gamme. Si l'un des trois manque, le prix affiché n'a pas de sens.",
                    "Méfiez-vous aussi des « tous horaires » sans délai annoncé : un chantier étalé sur trois semaines au lieu de cinq jours, c'est autant de temps à vivre dans le chantier.",
                ],
            },
            {
                h: "Comment comparer deux devis",
                b: [
                    "Posez la même question aux deux artisans : « la préparation est-elle incluse au forfait ? ». C'est elle qui sépare un chantier qui vieillit bien d'un chantier à refaire dans deux ans. Et exigez un devis détaillé poste par poste — c'est notre standard, sous 48 h.",
                ],
            },
        ],
    },
    {
        slug: "parquet-stratifie-guide",
        title: "Parquet stratifié : poses, prix et erreurs à éviter",
        excerpt:
            "Le sol le plus posé en rénovation : pourquoi le stratifié s'impose, comment bien le poser et quel budget prévoir.",
        cover: "https://images.unsplash.com/photo-1630699144919-681cf308ae82?q=80&w=1600&auto=format&fit=crop",
        date: "2026-02-24",
        minRead: 4,
        sections: [
            {
                h: "Pourquoi le stratifié s'est imposé en rénovation",
                b: [
                    "Le stratifié est un décor photographique plaqué sous pression sur un support en fibres haute densité : il imite le bois avec un réalisme bluffant, résiste aux rayures et au passage quotidien, et se pose en flottant — sans colle, sans poussière, souvent en une seule journée.",
                    "C'est aujourd'hui le meilleur rapport rendu / budget pour une rénovation intérieure de pièces sèches : chambres, séjour, couloirs.",
                ],
            },
            {
                h: "La pose réussie se joue avant la première lame",
                b: [
                    "Un stratifié flottant épouse les défauts du support : c'est pourquoi un ragréage préalable (enduit de lissage, à partir de 17 €/m²) est indispensable quand l'ancien sol est irrégulier. Ensuite vient la sous-couche acoustique — elle absorbe les bruits de pas et fait tout la différence à l'usage.",
                    "Les lames s'acclimatent 48 h dans la pièce avant la pose, et on garde toujours un jeu de dilatation de 8 mm en périphérie, masqué par les plinthes.",
                ],
            },
            {
                h: "Quel budget prévoir ?",
                b: [
                    "En pose seule, comptez entre 25 et 40 €/m² selon le format des lames et la complexité du calepinage. Le stratifié lui-même s'ajoute selon la gamme choisie, de l'entrée de gamme (chambres) au grand trafic AC4-AC5 (pièces de vie).",
                    "Ajoutez le ragréage si le support l'exige, et la dépose de l'ancien sol si besoin : tout figure, poste par poste, sur notre devis gratuit sous 48 h.",
                ],
            },
            {
                h: "Les trois erreurs à éviter",
                b: [
                    "Poser sans sous-couche acoustique (bruits de pas garantis), oublier le jeu de dilatation (lames qui gondolent), et poser du stratifié dans une pièce d'eau — là, on bascule sur le vinyle en lames, totalement imperméable.",
                    "Notre règle : pièces sèches en stratifié, zones humides en vinyle. Vous hésitez ? Demandez-nous, le conseil est gratuit.",
                ],
            },
        ],
    },
];
